import { defineMessages } from 'react-intl';

type MessageKeys = 'duplicateAgentErrorTitle' | 'duplicateAgentErrorDescription';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		duplicateAgentErrorTitle: {
			id: 'rovo-chat.agent-url-actions.duplicate-agent-error-title',
			defaultMessage: 'Failed to duplicate agent',
			description: 'Title of the error flag shown when duplicating an agent fails.',
		},
		duplicateAgentErrorDescription: {
			id: 'rovo-chat.agent-url-actions.duplicate-agent-error-description',
			defaultMessage: 'Something went wrong. Please try again.',
			description: 'Description of the error flag shown when duplicating an agent fails.',
		},
	});

export default message;
